import { Action } from "redux";
import {
  ADD_TO_FAVOURITES,
  ADD_TO_FAVOURITES_SUCCESS,
  FETCH_FAVOURITES,
  FETCH_FAVOURITES_ERROR,
  FETCH_FAVOURITES_SUCCESS,
  REMOVE_FROM_FAVOURITES,
  REMOVE_FROM_FAVOURITES_SUCCESS,
} from "./constants";
import { UnsetAuthAction } from "../auth/actions";

export interface FetchFavouritesAction extends Action {
  type: typeof FETCH_FAVOURITES;
}

export interface FetchFavouritesSuccessAction extends Action {
  type: typeof FETCH_FAVOURITES_SUCCESS;
  favourites: Favourite[];
}

export interface FetchFavouritesErrorAction extends Action {
  type: typeof FETCH_FAVOURITES_ERROR;
}

export interface AddToFavouritesAction extends Action {
  type: typeof ADD_TO_FAVOURITES;
  favourite: Favourite;
}

export interface AddToFavouriteSuccessAction extends Action {
  type: typeof ADD_TO_FAVOURITES_SUCCESS;
  favourites: Favourite[];
}

export const fetchFavourites = (): FetchFavouritesAction => ({
  type: FETCH_FAVOURITES,
});

export const addToFavourites = (
  favourite: Favourite
): AddToFavouritesAction => ({
  type: ADD_TO_FAVOURITES,
  favourite,
});

export interface RemoveFromFavouritesAction extends Action {
  type: typeof REMOVE_FROM_FAVOURITES;
  programId: string;
}

export interface RemoveFromFavouritesSuccessAction extends Action {
  type: typeof REMOVE_FROM_FAVOURITES_SUCCESS;
  favourites: Favourite[];
}

export const removeFromFavourites = (
  programId: string
): RemoveFromFavouritesAction => ({
  type: REMOVE_FROM_FAVOURITES,
  programId,
});

export type FavouriteAction =
  | FetchFavouritesAction
  | FetchFavouritesSuccessAction
  | FetchFavouritesErrorAction
  | AddToFavouritesAction
  | RemoveFromFavouritesAction
  | RemoveFromFavouritesSuccessAction
  | AddToFavouriteSuccessAction
  | UnsetAuthAction;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/favourites/actions.ts